export const INITIATING_CALL_FTE_MAX = 3
export const MED_REC_REVIEW_FTE_MAX = 2
